import { createAppRouter } from './router/createAppRouter';
import { AppProviders } from './providers/AppProviders';

const router = createAppRouter();

export function App() {
  return <AppProviders router={router} />;
}
